import {
  getStaticPathsGenerator,
  getStaticPropsGenerator,
} from '@cinch-nx/landing-feature-policy-page'
import { traceFunction } from '@core/datadog-server'

const path = 'policies'

export const getStaticProps = traceFunction(
  'policies getStaticProps',
  getStaticPropsGenerator(path),
)

export const getStaticPaths = traceFunction(
  'policies getStaticPaths',
  getStaticPathsGenerator(path),
)

export { PolicyPageFeature as default } from '@cinch-nx/landing-feature-policy-page'
